import { render, staticRenderFns } from "./Explore.vue?vue&type=template&id=2947edf5&scoped=true"
import script from "./Explore.vue?vue&type=script&lang=js"
export * from "./Explore.vue?vue&type=script&lang=js"
import style0 from "./Explore.vue?vue&type=style&index=0&id=2947edf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947edf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
